import { TopicItemProps } from "apis";
import { lazy } from "react";

export const PageAdminTopic = lazy(() => import("./List"));
export const PageAdminTopicCreate = lazy(() => import("./Add"));
export const PageAdminTopicUpdate = lazy(() => import("./Edit"));

export interface FormTopicValuesProps extends TopicItemProps { }